import {MaterialType} from '@domain/material-storage'

export const OTHER_MATERIAL_TYPES: MaterialType[] = [
  MaterialType.Fuels,
  MaterialType.EnhancersForCement,
  MaterialType.AdditivesForClinker,
  MaterialType.NonReportedMaterials,
  MaterialType.OtherGroundProductsThanCement
]
